import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import Swal from "sweetalert2";
import Hexapi from "../utility/HexAPI/Hexapi";


const Followupdelete = ({ show, hide, followupdata, agentID, ActionModal }) => {
  console.log(followupdata, "followupdata");
  const [password, setpassword] = useState("");
  const deletefollowup = async (e) => {
    e.preventDefault();
    if (password == "") {
      console.log(password, "password");
      Swal.fire({
        title: "Oops...",
        html: "Password not filled",
      });
      return;
    }

    try {
      let obj = {
        query: `[dbo].[HCMS_Proc_Followup_Omit]
	@AgentID='{0}',
	@FollowupID='{1}',
	@Password ='{2}'`,
        queryArr: [`${agentID}`, `${followupdata.followupid}`, `${password}`],
      };
      const resp = await Hexapi(obj);
      console.log(resp, "response");
      if (resp && resp[""] && resp[""][0] && resp[""][0].command == 1) {
        setpassword("");
        hide();
        ActionModal();
      } else if (resp && resp[""] && resp[""][0] && resp[""][0].command == 0) {
        const msg = resp[""][0].msg;
        Swal.fire({
          title: "Oops",
          html: msg,
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Oops...",
        html: "Something went wrong.....",
      });
    }
  };

  return (
    <div>
      <Modal
        centered
        show={show}
        onHide={() => hide()}
        keyboard={false}
        backdrop="static"
        style={{ backgroundColor: "rgba(0,0,0,0.9)" }}
      >
        <Modal.Header closeButton style={{ padding: "10px 15px" }}>
          <Modal.Title style={{ fontSize: "20px" }}>
            Follow Up Delete
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <label style={{ fontWeight: "600" }}>
            Password <span style={{ color: "red" }}>*</span>
          </label>
          <input
            class="form-control  mt-1"
            type="password"
            onChange={(e) => setpassword(e.target.value)}
            value={password}
            autoComplete={"new-password"}
          />

          <div style={{ width: "100%", textAlign: "center" }}>
            <button
              onClick={(e) => deletefollowup(e)}
              className="data-verify"
              disabled={password == "" && true}
              style={{
                backgroundColor: password == "" && "gray",
                border: password == "" && "gray",
                color: password == "" && "white",
              }}
            >
              Delete
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Followupdelete;
